var _defs, _path, _path2, _path3, _path4, _path5, _path6, _rect, _polygon, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEducaIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    width: 500,
    height: 500,
    className: "illustration",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f2948b;}.cls-2{fill:#f9a498;}.cls-3{fill:#ffbeb3;}.cls-4{fill:#24285b;}.cls-5{fill:#171c44;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Learning") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.43,196.77h0a20.75,20.75,0,0,1,20.75,20.75V357.7a0,0,0,0,1,0,0h-41.5a0,0,0,0,1,0,0V217.52A20.75,20.75,0,0,1,305.43,196.77Z",
    transform: "translate(302.53 -135.24) rotate(47.37)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M353.43,203.93h0a20.75,20.75,0,0,1,20.75,20.75V364.87a0,0,0,0,1,0,0h-41.5a0,0,0,0,1,0,0V224.68A20.75,20.75,0,0,1,353.43,203.93Z",
    transform: "translate(323.29 -168.24) rotate(47.37)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M456,244.89h0a21.9,21.9,0,0,0-30-.62l-70.71,65.1-47.9,1.48a28.91,28.91,0,0,0,2.7-12.22h0a29,29,0,0,0-29-29H160.4A58.91,58.91,0,0,0,111,296.41L86.12,334.72,38.76,397a3,3,0,0,0,1.49,4.68L165,440.82a3,3,0,0,0,3.18-.91l44-51.63,109.69-15a95.94,95.94,0,0,0,51.91-24.45l81.63-75.15A19.81,19.81,0,0,0,456,244.89Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M164.66,319.48H289.83a22.11,22.11,0,0,0,17.41-8.43l.15-.2,4.74-.15s-6.68,12.9-11.4,15-124.9,2.07-124.9,2.07Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M372.26,163h0a14.37,14.37,0,0,0-9.65,13.58v18.67h19.3V176.6A14.37,14.37,0,0,0,372.26,163Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M165.05,188.52c0,8.15,38,14.75,84.95,14.75S335,196.67,335,188.52V118.74H165.05Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 368.37,
    y: 110.61,
    width: 7.78,
    height: 56.04
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "178.26 138.63 256.36 176.34 334.95 164.88 334.95 134.45 178.26 138.63"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M248.73,159.81l-148.57-45a4.37,4.37,0,0,1,0-8.36l148.57-45a4.39,4.39,0,0,1,2.54,0l148.57,45a4.37,4.37,0,0,1,0,8.36l-148.57,45A4.39,4.39,0,0,1,248.73,159.81Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducaIcon);
export default __webpack_public_path__ + "static/media/educaIcon.59a713c2e40c00bb091ff6fb32b993b1.svg";
export { ForwardRef as ReactComponent };